<div class="animate-pulse" [class]="(circle ? 'rounded-full' : rounded) + ' ' + background"
  [style.width]="width" [style.height]="circle ? width : height"></div>
